import { render, staticRenderFns } from "./incident_action.vue?vue&type=template&id=2ff90ab2"
import script from "./incident_action.vue?vue&type=script&lang=js"
export * from "./incident_action.vue?vue&type=script&lang=js"
import style0 from "./incident_action.vue?vue&type=style&index=0&id=2ff90ab2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports